import FLD from "../model/ISIN";
import ISIN_FIELD from "../model/ISIN";

/** Interest fields affected by the EY/DM rule */
export const INTEREST_SOURCES: string[] = [
    FLD.interestRate,
    FLD.interestType,
    FLD.interestFrequency,
    FLD.interestFirstPayDate,
    FLD.interestPayDay,
    FLD.interestPayMonth
];

export const EXCERCICEPRICE_SOURCES: string[] = [
    FLD.exercisePriceCurrency,
    FLD.exercisePrice
];

export const isInterestRateCase = (cfi?: string) => {
    const s = (cfi ?? "").toString().trim().toUpperCase();
    const prefixes = ["EY", "DS", "DE", "DM", "MM", "MC"];
    return prefixes.some(p => s.startsWith(p));
};

export const isExcercisePriceCase = (cfi?: string) => {
    const s = (cfi ?? "").toString().trim().toUpperCase();
    const prefixes = ["EY", "DS", "DE"];
    return prefixes.some(p => s.startsWith(p));
};

export function isInterrestrateActive(source: string, formData: any): boolean {
    return INTEREST_SOURCES.includes(source) && isInterestRateCase(formData?.cfiCode);
}

export function isInterrestrateVisible(visible: boolean, eyActive: boolean): boolean {
    return eyActive ? true : visible;
}

export function isInterrestrateRequired(required: boolean, eyActive: boolean): boolean {
    return eyActive ? false : required;
}

export function isExcercisePriceActive(source: string, formData: any): boolean {
    return EXCERCICEPRICE_SOURCES.includes(source) && isExcercisePriceCase(formData?.cfiCode);
}

export function isExcercisePriceVisible(visible: boolean, active: boolean): boolean {
    return active ? true : visible;
}

export function isExcercisePriceRequired(required: boolean, active: boolean): boolean {
    return active ? false : required;
}

export const isSkipInterestTypeCrossValidationCase = (cfi?: string): boolean => {
    const s = (cfi ?? "").toString().trim().toUpperCase();
    const prefixes = ["EY", "DM", "MM", "MC"];
    return prefixes.some(p => s.startsWith(p));
};

export const isInterestRateOptionalInterestRateCrossValidation = (cfi?: string): boolean => {
    const s = (cfi ?? "").toString().trim().toUpperCase();
    const prefixes = ["EY", "DM"];
    return prefixes.some(p => s.startsWith(p));
};

export const MATURITY_SOURCES = [
    ISIN_FIELD.maturityDate,
    ISIN_FIELD.maturityDateCode
];

export function isMaturityOptionalCase(cfi?: string): boolean {
    if (!cfi) return false;
    const t = cfi.trim();
    if (t.length < 2) return false;

    const p = t.substring(0, 2).toUpperCase();
    return ["EY", "DS", "DE", "DM", "MM", "MC"].includes(p);
}
